import { useSyncExternalStore } from 'react';

import {
  getBackendAvailabilityUiSnapshot,
  subscribeBackendAvailabilityUi,
} from '../../utils/backend-availability';

export function useBackendAvailable(): boolean {
  return useSyncExternalStore(
    subscribeBackendAvailabilityUi,
    getBackendAvailabilityUiSnapshot,
    () => true
  );
}
